import React from 'react';

function Columns(props) {
    const fill = props.fill || 'currentColor';
    const className = props.className;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            className={className}
        >
            <rect x="2" y="3" width="5" height="14" rx="1" stroke={fill} strokeWidth="1.5" fill="none" />
            <rect x="9" y="3" width="5" height="14" rx="1" stroke={fill} strokeWidth="1.5" fill="none" />
            <rect x="16" y="3" width="2" height="14" rx="1" stroke={fill} strokeWidth="1.5" fill="none" />
        </svg>
    );
}

export default Columns;
